export default __webpack_public_path__ + "static/media/central_andes_1_2.380f74a1.JPG";